__turbopack_context__.v({
  "column": "dVA5RG_column",
  "grow": "dVA5RG_grow",
  "label": "dVA5RG_label",
  "preset": "dVA5RG_preset",
  "presetLabel": "dVA5RG_presetLabel",
  "presetValue": "dVA5RG_presetValue",
  "presets": "dVA5RG_presets",
  "recommendation": "dVA5RG_recommendation",
  "recommendationDot": "dVA5RG_recommendationDot",
  "row": "dVA5RG_row",
  "stepper": "dVA5RG_stepper",
  "track": "dVA5RG_track",
  "underLabel": "dVA5RG_underLabel",
  "value": "dVA5RG_value",
  "valueInput": "dVA5RG_valueInput",
});
